var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40853 8.32992L2.99184 5.89369C2.62406 5.52294 2.02461 5.52294 1.65684 5.89369V5.89369C1.29322 6.26025 1.29322 6.85143 1.65684 7.21799L5.40853 11L13.8432 2.49719C14.2068 2.13064 14.2068 1.53945 13.8432 1.17289V1.17289C13.4754 0.802144 12.8759 0.802145 12.5082 1.17289L5.40853 8.32992Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0ff62228970707bb2193bb4a5e08c3ea.svg";
export { ForwardRef as ReactComponent };